import React from "react";
import styled from "styled-components";
import GuideCorrect from "./assets/guide_correct.png";
import GuideIncorrect1 from "./assets/guide_incorrect_1.png";
import GuideIncorrect2 from "./assets/guide_incorrect_2.png";
import { useTranslation } from "src/hooks";
import { Box, Text } from "../../../components";

export const ListContainerEl = styled.ul`
  list-style: disc;
  padding-left: 1em;
  font-family: ${(props) => props.theme.text.fontFamily.normal};
  line-height: ${(props) => props.theme.text.lineHeight.normal};
  color: ${(props) => props.theme.colors.text.soft};
`;

export const ListEl = styled.li`
  margin-bottom: ${(p) => p.theme.dimension.spacing.l}px;
  margin-left: ${(p) => p.theme.dimension.spacing.s}px;
`;

export const ImageContainerEl = styled(Box)`
  display: flex;
  margin-top: ${(p) => p.theme.dimension.spacing.xxl}px;
  gap: ${(p) => p.theme.dimension.spacing.l}px;
`;

export const GuideModal = () => {
  const translate = useTranslation();
  const path = "owner_info.selfie.guide";

  return (
    <>
      <Text marginBottomXxl marginTopS fontWeight="demi">
        {translate(`${path}.title`)}
      </Text>
      <ListContainerEl>
        <ListEl>{translate(`${path}.point_1`)}</ListEl>
        <ListEl>{translate(`${path}.point_2`)}</ListEl>
        <ListEl>{translate(`${path}.point_3`)}</ListEl>
      </ListContainerEl>
      <ImageContainerEl>
        <img src={GuideCorrect} alt="correct selfie example" />
        <img src={GuideIncorrect1} alt="incorrect selfie example 1" />
        <img src={GuideIncorrect2} alt="incorrect selfie example 2" />
      </ImageContainerEl>
    </>
  );
};
